export default {
    parts: [],
    activePart: {},
    managePartDialog: false,
    manageDeletePartDialog: false
}
